import Filter, { SelectedFilters } from '../../types/Filter/Filter';
import { UnitTour } from '../../types/Unit/Unit';
import { RangeOption } from '../../types/Option/Option';

export default function filterUnitTours(
    unitTours: UnitTour[],
    filtersConfig: Filter[],
    selectedFilters: SelectedFilters
): UnitTour[] {
    return unitTours.filter((unitTour) => {
        const isUnitTourFiltered = filtersConfig.reduce<boolean>(
            (isFiltered, filter) => {
                if (
                    !isFiltered ||
                    selectedFilters[filter.key] === undefined ||
                    selectedFilters[filter.key] === null
                )
                    return isFiltered;

                if (filter.key === 'unitSize' && unitTour.unitSize) {
                    const option = (filter.options as RangeOption[]).find(
                        (option) => option.key === selectedFilters[filter.key]
                    );
                    if (!option) return isFiltered;

                    const range = option.range;
                    const unitSize = unitTour.unitSize.num;

                    if (!range.from && range.to) {
                        return unitSize <= range.to;
                    }

                    if (range.from && !range.to) {
                        return unitSize >= range.from;
                    }

                    return range.from && range.to
                        ? unitSize >= range.from && unitSize <= range.to
                        : isFiltered;
                }

                return (
                    unitTour[filter.key as keyof UnitTour] ===
                    selectedFilters[filter.key]
                );
            },
            true
        );

        return isUnitTourFiltered;
    });
}
